try {
  $.fn.tooltip.Constructor.DEFAULTS.placement = 'auto bottom';
  $.fn.tooltip.Constructor.DEFAULTS.template =
    '<div class="tooltip cah-external" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';
} catch (e) {
  console.error('Tooltip instantiation occurred prior to jQuery load\n\n', e);
}
